function get (name) {
  if (process.browser) {
    try {
      return JSON.parse(sessionStorage.getItem(name))
    } catch (e) {
      console.log('!!!', e)
      return null
    }
  }
}

function set (name, data) {
  if (process.browser) {
  try {
    sessionStorage.setItem(name, JSON.stringify(data))
  } catch (e) {
    console.log('!!!', e)
  }
  }
}

function remove (name) {
  if (process.browser) {
    try {
      sessionStorage.removeItem(name)
    } catch (e) {
      console.log('!!!', e)
      // console.log(e)
    }
  }
}

export default {
  get: get,
  set: set,
  remove: remove
}



// WEBPACK FOOTER //
// ./src/mods/sessionStorage.js